// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2tZML","label":"LabeledBox_label__2l9jk"};